module.exports = __webpack_public_path__ + "static/media/nf.103f21a1.webp";